import processSharedEnrollmentData from '../shared/enrollmentReducerParsers';
import { LICENSE } from '../../../constants/reading/CommonConstants';

const reformatLicensingInfo = licensingList => {
    const reformattedlicensingList = [...licensingList];
    if (licensingList.includes(LICENSE.OLS)) {
        reformattedlicensingList.push(LICENSE.OL);
    }

    return reformattedlicensingList;
};

const processEnrollmentData = ({ data, districtId, schoolId, classId, period, burstGroupId }) => {
    const processedData = processSharedEnrollmentData({
        data,
        districtId,
        schoolId,
        classId,
        period,
    });
    return {
        ...processedData,
        licensingInfo: reformatLicensingInfo(processedData.licensingInfo),
        burstGroupUid: burstGroupId || processedData.burstGroupUid,
    };
};

export default processEnrollmentData;
